import React, { useEffect } from 'react'
import { useNewTranslation } from 'hooks'
import { theme } from 'theme'
import Button from 'components/Shared/Button/Button'
import ModalStyledPopup from 'components/ModalStyledPopup'
import Icon from 'components/Icon/Icon'
import styled from 'particles/themes/styled'
interface ConfirmPopUpProps {
    show: boolean
    setShow: (arg: any) => void
    onConfirm: () => void
    onClose?: () => void
    closeText?: string
    confirmText?: string
    width?: string
    iconColor?: string
}
interface ContainerProps {
    iconColor?: string
}

const Container = styled.div<ContainerProps>`
    .icon {
        display: flex;
        justify-content: center;
        padding-top: 1.5rem;
        margin-bottom: 8px;
        svg {
            path {
                fill: ${({ iconColor }) => (iconColor ? iconColor : theme.newColors.primary500)};
            }
        }
    }
    .buttons {
        display: flex;
        justify-content: space-around;
        margin: ${theme.spacing.xs} 0;
    }
    button {
        min-width: 158px;
    }
`
const ConfirmPopUp: React.FC<ConfirmPopUpProps> = ({
    show,
    setShow,
    onConfirm,
    onClose,
    closeText,
    confirmText,
    children,
    width = '571px',
    iconColor,
}) => {
    const [t] = useNewTranslation()
    const onCloseAction = () => {
        if (onClose) {
            onClose()
        }
        setShow(false)
    }

    useEffect(() => {
        window.addEventListener('popstate', function () {
            setShow(false)
        })
        return (): void =>
            window.removeEventListener('popstate', function () {
                setShow(false)
            })
    }, [])

    return (
        <ModalStyledPopup open={show} closeOnDocumentClick={false} width={width}>
            <Container iconColor={iconColor}>
                <div className="icon">
                    <Icon.Message width={'30px'} height={'30px'} />
                </div>
                {children}
                <div className="buttons">
                    <Button
                        size="m"
                        buttonType="secondary"
                        onClick={onCloseAction}
                        text={closeText ? closeText : t('button.cancel')}
                    />
                    <Button
                        size="m"
                        buttonType="primary"
                        onClick={onConfirm}
                        text={confirmText ? confirmText : t('button.proceed')}
                    />
                </div>
            </Container>
        </ModalStyledPopup>
    )
}

export default ConfirmPopUp
